"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _Beitrag = _interopRequireDefault(require("../model/Beitrag"));
var _BeitragBase = _interopRequireDefault(require("../model/BeitragBase"));
var _BeitragCreate = _interopRequireDefault(require("../model/BeitragCreate"));
var _HTTPValidationError = _interopRequireDefault(require("../model/HTTPValidationError"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * KFV LDS API
 * Die KFV LDS API bietet eine Schnittstelle zum Backend der PWA.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
* Beitrag service.
* @module api/BeitragApi
* @version 0.0.1
*/
class BeitragApi {
  /**
  * Constructs a new BeitragApi. 
  * @alias module:api/BeitragApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  constructor(apiClient) {
    this.apiClient = apiClient || _ApiClient.default.instance;
  }

  /**
   * Callback function to receive the result of the createBeitragBeitragPost operation.
   * @callback module:api/BeitragApi~createBeitragBeitragPostCallback
   * @param {String} error Error message, if any.
   * @param {module:model/Beitrag} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Create Beitrag
   * @param {module:model/BeitragCreate} beitragCreate 
   * @param {module:api/BeitragApi~createBeitragBeitragPostCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link module:model/Beitrag}
   */
  createBeitragBeitragPost(beitragCreate, callback) {
    let postBody = beitragCreate;
    // verify the required parameter 'beitragCreate' is set
    if (beitragCreate === undefined || beitragCreate === null) {
      throw new Error("Missing the required parameter 'beitragCreate' when calling createBeitragBeitragPost");
    }
    let pathParams = {};
    let queryParams = {};
    let headerParams = {};
    let formParams = {};
    let authNames = ['JWTBearer'];
    let contentTypes = ['application/json'];
    let accepts = ['application/json'];
    let returnType = _Beitrag.default;
    return this.apiClient.callApi('/beitrag/', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }

  /**
   * Callback function to receive the result of the deleteBeitragBeitragBeitragIdDelete operation.
   * @callback module:api/BeitragApi~deleteBeitragBeitragBeitragIdDeleteCallback
   * @param {String} error Error message, if any.
   * @param {Object} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Delete Beitrag
   * @param {Number} beitragId 
   * @param {module:api/BeitragApi~deleteBeitragBeitragBeitragIdDeleteCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link Object}
   */
  deleteBeitragBeitragBeitragIdDelete(beitragId, callback) {
    let postBody = null;
    // verify the required parameter 'beitragId' is set
    if (beitragId === undefined || beitragId === null) {
      throw new Error("Missing the required parameter 'beitragId' when calling deleteBeitragBeitragBeitragIdDelete");
    }
    let pathParams = {
      'beitrag_id': beitragId
    };
    let queryParams = {};
    let headerParams = {};
    let formParams = {};
    let authNames = ['JWTBearer'];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = Object;
    return this.apiClient.callApi('/beitrag/{beitrag_id}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }

  /**
   * Callback function to receive the result of the readBeitrageBeitragGet operation.
   * @callback module:api/BeitragApi~readBeitrageBeitragGetCallback
   * @param {String} error Error message, if any.
   * @param {Array.<module:model/Beitrag>} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Read Beitrage
   * @param {Number} feuerwehrId 
   * @param {Object} opts Optional parameters
   * @param {Number} [skip = 0)] Einträge die beim Abrufen aus der Datenbank übersprungen werden sollen.
   * @param {Number} [limit = 20)] Anzahl der Einträge die abgerufen werden sollen.
   * @param {module:api/BeitragApi~readBeitrageBeitragGetCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link Array.<module:model/Beitrag>}
   */
  readBeitrageBeitragGet(feuerwehrId, opts, callback) {
    opts = opts || {};
    let postBody = null;
    // verify the required parameter 'feuerwehrId' is set
    if (feuerwehrId === undefined || feuerwehrId === null) {
      throw new Error("Missing the required parameter 'feuerwehrId' when calling readBeitrageBeitragGet");
    }
    let pathParams = {};
    let queryParams = {
      'feuerwehr_id': feuerwehrId,
      'skip': opts['skip'],
      'limit': opts['limit']
    };
    let headerParams = {};
    let formParams = {};
    let authNames = ['JWTBearer'];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = [_Beitrag.default];
    return this.apiClient.callApi('/beitrag/', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }

  /**
   * Callback function to receive the result of the updateBeitragBeitragBeitragIdPatch operation.
   * @callback module:api/BeitragApi~updateBeitragBeitragBeitragIdPatchCallback
   * @param {String} error Error message, if any.
   * @param {module:model/Beitrag} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Update Beitrag
   * @param {Number} beitragId 
   * @param {module:model/BeitragBase} beitragBase 
   * @param {module:api/BeitragApi~updateBeitragBeitragBeitragIdPatchCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link module:model/Beitrag}
   */
  updateBeitragBeitragBeitragIdPatch(beitragId, beitragBase, callback) {
    let postBody = beitragBase;
    // verify the required parameter 'beitragId' is set
    if (beitragId === undefined || beitragId === null) {
      throw new Error("Missing the required parameter 'beitragId' when calling updateBeitragBeitragBeitragIdPatch");
    }
    // verify the required parameter 'beitragBase' is set
    if (beitragBase === undefined || beitragBase === null) {
      throw new Error("Missing the required parameter 'beitragBase' when calling updateBeitragBeitragBeitragIdPatch");
    }
    let pathParams = {
      'beitrag_id': beitragId
    };
    let queryParams = {};
    let headerParams = {};
    let formParams = {};
    let authNames = ['JWTBearer'];
    let contentTypes = ['application/json'];
    let accepts = ['application/json'];
    let returnType = _Beitrag.default;
    return this.apiClient.callApi('/beitrag/{beitrag_id}', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }
}
exports.default = BeitragApi;